let defaultRoomPurposeModel = {
    title: '',
    order: 0,
};

export default defaultRoomPurposeModel;

